/**
 * Loads geometry for the selected service item and creates the ArcGIS graphic.
 */

import { useEffect, useState } from "react";
import APIHelper from "@giscon/utils.api-helper-esri";
import { endpoints } from "../../../configs/config";

export default function useServiceItemGraphic({ service, selectedItem }) {
  const [graphic, setGraphic] = useState(null);
  const [geometryError, setGeometryError] = useState(null);

  useEffect(() => {
    if (!selectedItem || !service) {
      setGraphic(null);
      return;
    }

    let aborted = false;
    setGeometryError(null);

    const geometryUrl = endpoints.serviceItemUrl(
      service.Id,
      selectedItem.ObjectId,
    );

    fetch(geometryUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (aborted) return;

        // API Response: { geometry: { type: 'Polygon', spatialReference: { latestWkid, wkid }, rings: [...] }, success: true, errorMessage: null }
        if (data && data.success && data.geometry) {
          const geometry = {
            ...data.geometry,
            type: (data.geometry.type || "").toLowerCase(),
          };

          const nextGraphic = APIHelper.createGraphic(
            geometry,
            {
              type: "simple-fill",
              style: "none",
              color: [0, 191, 255, 0.5],
              outline: {
                color: [144, 0, 0, 0.75],
                width: 2,
                style: "solid",
              },
            },
            {
              ObjectId: selectedItem.ObjectId,
              Name: selectedItem.Name,
              displayLabel: selectedItem.displayLabel,
              GisServiceId: selectedItem.GisServiceId,
            },
          );

          setGraphic(nextGraphic);
          setGeometryError(null);
          return;
        }

        if (data && data.success === false) {
          const err = data.errorMessage || "Unknown error";
          // eslint-disable-next-line no-console
          console.error("Error loading geometry:", err);
          setGeometryError(err);
          return;
        }

        console.error("Error loading geometry: unexpected response", data);
        setGeometryError("No geometry returned from service");
      })
      .catch((error) => {
        if (!aborted) {
          // eslint-disable-next-line no-console
          console.error("Error loading geometry:", error);
          setGeometryError(error.message);
        }
      });

    return () => {
      aborted = true;
    };
  }, [selectedItem, service]);

  return { graphic, setGraphic, geometryError };
}
